"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardWithRows = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const examples_styles_1 = require("../examples-styles");
const Grid = styled_components_1.default.div.withConfig({ displayName: "reports-Grid", componentId: "reports-k2wr8v" }) `
  display: grid;
  grid-gap: 24px;
  width: 100%;
`;
const GridHeader = (0, styled_components_1.default)(base_react_components_1.Header).withConfig({ displayName: "reports-GridHeader", componentId: "reports-1q8vbad" }) `
  padding-bottom: 8px;
  border-bottom: 2px solid ${base_react_components_1.theme.neutral200};
`;
const GridSubheader = (0, styled_components_1.default)(Grid).withConfig({ displayName: "reports-GridSubheader", componentId: "reports-dcwd7i" }) `
  align-items: flex-start;
  grid-template-columns: 1fr;
  grid-auto-rows: auto;
  margin-bottom: 8px;
  grid-gap: 24px;

  @media (${base_react_components_1.theme.forLargerThanPhone}) {
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    width: 100%;
    & > * {
      width: 100%;
    }
    grid-auto-rows: 1fr;
  }
`;
const GridRowBody = styled_components_1.default.div.withConfig({ displayName: "reports-GridRowBody", componentId: "reports-185joqp" }) `
  grid-template-columns: 1fr;
`;
const CardHeader = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement(GridHeader, Object.assign({ size: "lg" }, rest), children));
};
const CardSubheader = ({ columns = 2, children }) => (react_1.default.createElement(GridSubheader, { columns: columns }, children));
const CardBody = ({ children }) => react_1.default.createElement(GridRowBody, null, children);
/**
 * Detail Card
 *
 * @returns ReactElement
 */
const CardWithRows = (_a) => {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (react_1.default.createElement(examples_styles_1.StyledReportCardsContainer, null,
        react_1.default.createElement(base_react_components_1.StandardCard, Object.assign({}, rest),
            react_1.default.createElement(Grid, null, children))));
};
exports.CardWithRows = CardWithRows;
exports.CardWithRows.Header = CardHeader;
exports.CardWithRows.Subheader = CardSubheader;
exports.CardWithRows.Body = CardBody;
exports.default = exports.CardWithRows;
//# sourceMappingURL=index.js.map